import * as yup from 'yup';

// Schémas de validation Yup
const addressValidationSchema = yup.object().shape({
    address: yup.string().required('L\'adresse est requise'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
});

export default addressValidationSchema